// Provider payloads can be objects or JSON strings from stored profile data.
const parsePayload = (payload) => {
  if (typeof payload === "string") {
    try {
      payload = JSON.parse(payload);
    } catch {
      return null;
    }
  }
  return payload && typeof payload === "object" && !Array.isArray(payload)
    ? payload
    : null;
};

// Prefer populated legacy data when both wrappers exist. Do not alter the raw payload.
export const getPersonData = (payload) => {
  const data = parsePayload(payload);
  const legacy = parsePayload(data?.person);
  const current = parsePayload(data?.person_info);
  return legacy && Object.keys(legacy).length > 0 ? legacy : current ?? legacy;
};

// Standalone MyInfo also returned unwrapped personal attributes in older flows.
export const getMyInfoData = (payload) =>
  getPersonData(payload) ?? parsePayload(payload);
